export default class TabellaCustomClass {
    constructor(arg = undefined) {
      if (arg != undefined) {
        const campi = this.setControlli();
        campi.forEach((c) => {
          this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
        });
      } else {
        const campi = this.setControlli();
        campi.forEach((c) => {
          this[c.nome] = c.default_val;
        });
      }
    }
  
    // Metodo per resettare tutte i campi
    reset() {
      const campi = this.setControlli();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  
    setControlli() {
      const campi = [
        { nome: "id_query", default_val: -1 },
        { nome: "titolo", default_val: "" },
        { nome: "modulo", default_val: "" },
        { nome: "colonne", default_val: [] },
        { nome: "query", default_val: [] },
        { nome: "params", default_val: [] },
        { nome: "validita", default_val: 1 },
      ];
      return campi;
    }
  }